<div class="popup-overlay" *ngIf="record" (click)="close()">
  <div class="popup-card" (click)="$event.stopPropagation()">

    <!-- Popup Header -->
    <div class="popup-header">
      <div class="popup-title">
        <i class="fa-solid fa-certificate popup-title-icon"></i>
        <span>Certificate Details</span>
      </div>
      <button class="popup-close" (click)="close()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Risk Banner -->
    <div class="popup-risk-banner" [ngClass]="getRiskClass(record.riskLevel)">
      <i class="fa-solid fa-shield-halved"></i>
      <span>Risk Level: <strong>{{ record.riskLevel || 'LOW' }}</strong></span>
    </div>

    <div class="popup-body">

      <!-- Certificate Info Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-id-card"></i>
          <span>Certificate Information</span>
        </div>
        <div class="popup-grid">
          <div class="popup-field">
            <span class="field-label">Common Name</span>
            <span class="field-value">{{ record.commonName }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Serial Number</span>
            <span class="field-value mono">{{ record.serialNumber }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Issuer Organization</span>
            <span class="field-value">{{ record.issuerOrganization || '—' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Issuer Common Name</span>
            <span class="field-value">{{ record.issuerCommonName || '—' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Wildcard</span>
            <span class="field-value">
              <span class="bool-badge" [ngClass]="record.isWildcard ? 'bool-yes' : 'bool-no'">
                {{ record.isWildcard ? 'Yes' : 'No' }}
              </span>
            </span>
          </div>
          <div class="popup-field">
            <span class="field-label">Pre-certificate</span>
            <span class="field-value">
              <span class="bool-badge" [ngClass]="record.isPrecert ? 'bool-yes' : 'bool-no'">
                {{ record.isPrecert ? 'Yes' : 'No' }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- Validity Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-calendar-days"></i>
          <span>Validity Period</span>
        </div>
        <div class="popup-grid">
          <div class="popup-field">
            <span class="field-label">Not Before</span>
            <span class="field-value">{{ record.notBefore | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Not After (Expiry)</span>
            <span class="field-value">{{ record.notAfter | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Days Remaining</span>
            <span class="field-value">
              <span class="days-badge" [ngClass]="getDaysClass(record.notAfter)">
                {{ getDaysRemaining(record.notAfter) < 0 ? 'Expired' : getDaysRemaining(record.notAfter) + ' days' }}
              </span>
            </span>
          </div>
          <div class="popup-field">
            <span class="field-label">Inserted Time</span>
            <span class="field-value">{{ record.insertedTime | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
        </div>
      </div>

      <!-- DNS Names Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-sitemap"></i>
          <span>DNS Names / SANs ({{ record.dnsNames?.length || 0 }})</span>
        </div>
        <div class="dns-list">
          <span *ngFor="let san of record.dnsNames" class="san-chip">{{ san }}</span>
          <span *ngIf="!record.dnsNames?.length" style="opacity: 0.5; font-size: 14px;">None</span>
        </div>
      </div>

      <!-- TLS Section -->
      <div class="popup-section" *ngIf="record.tls?.length">
        <div class="popup-section-title">
          <i class="fa-solid fa-lock"></i>
          <span>TLS Version Support</span>
        </div>
        <div class="tls-grid">
          <div class="tls-row" *ngFor="let t of record.tls">
            <span class="tls-version">{{ t.version }}</span>
            <span class="tls-status-badge" [ngClass]="getTlsClass(t.supported)">
              <i class="fa-solid" [ngClass]="t.supported ? 'fa-check' : 'fa-xmark'" style="margin-right: 5px;"></i>
              {{ t.supported ? 'Supported' : 'Not Supported' }}
            </span>
            <span class="tls-warning" *ngIf="t.supported && (t.version === 'TLSv1' || t.version === 'TLSv1.1')">
              <i class="fa-solid fa-triangle-exclamation"></i> Insecure
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
